<div class="radio-section">
  <app-radio 
    class="radio"
    [props]="radioProps"
    [(ngModel)]="radioState"
    (click)="handleFrequencyChange()"
  ></app-radio>
</div>

